import axios, { AxiosRequestConfig } from "axios";
import { trace as startTrace } from "firebase/performance";
import { perf } from "../../utils/firebase";

interface IPayload {
  params: any;
  selfieId: string | null;
}

export const applyTransfer = async (payload: IPayload) => {
  const url = `${process.env.REACT_APP_GCP_BASE_URL}/agr/api/hair/v4/selfies/${payload.selfieId}`;
  const axiosConfig: AxiosRequestConfig = {
    url: url,
    method: "PUT",
    params: payload.params,
    headers: {
      "x-api-key": process.env.REACT_APP_GCP_API_KEY,
      "Content-Type": "application/json",
    },
  };
  const trace = startTrace(perf, `Api call: ${url}`);
  trace.start();

  try {
    const response = await axios(axiosConfig);
    return response;
  } catch (error) {
    throw error;
  } finally {
    trace.stop();
  }
};

export const getTransfer = async (payload: IPayload) => {
  if (!payload.selfieId) return undefined;

  const url = `${process.env.REACT_APP_GCP_BASE_URL}/agr/api/hair/v4/selfies/${payload.selfieId}/transfers`;

  const axiosConfig: AxiosRequestConfig = {
    url: url,
    method: "GET",
    params: payload.params,
    headers: {
      "x-api-key": process.env.REACT_APP_GCP_API_KEY,
      "Content-Type": "application/json",
    },
  };

  const trace = startTrace(perf, `Api call: ${url}`);
  trace.start();

  try {
    const response = await axios(axiosConfig);
    return response;
  } catch (error) {
    throw error;
  } finally {
    trace.stop();
  }
};
